import { useCallback, useRef, useState } from 'react';

export const useStateRef = <T>(initialState: T) => {
  const [state, setState] = useState(initialState);
  const ref = useRef(initialState);

  const setStateAndRef = useCallback((newState: T) => {
    setState(newState);
    ref.current = newState;
  }, []);

  return [state, setStateAndRef, ref] as const;
};
